import { Link } from 'react-router-dom';
import { heroContent, statsItems } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Expansive%20lush%20green%20lawn%20in%20a%20beautiful%20garden%20setting%20with%20soft%20morning%20sunlight%20streaming%20through%20trees%2C%20dew%20drops%20on%20grass%20blades%2C%20peaceful%20natural%20atmosphere%2C%20elegant%20landscape%20design%2C%20vibrant%20emerald%20green%20tones%2C%20artistic%20photography%20style%20with%20dreamy%20bokeh%20effect&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
            <span className="text-xs md:text-sm text-background-50/90 font-medium tracking-wide">
              品质保证 · 正品直达
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-4 tracking-tight leading-tight">
            {heroContent.title}
          </h1>

          <p className="text-lg md:text-xl text-background-50/80 font-heading italic mb-6">
            {heroContent.subtitle}
          </p>

          <p className="max-w-2xl text-sm md:text-base text-background-50/70 leading-relaxed mb-10">
            {heroContent.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/categories"
              className="px-8 py-3 text-sm font-medium text-background-50 bg-accent-500 rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
            >
              {heroContent.ctaPrimary}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 text-sm font-medium text-background-50 border border-background-50/40 rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroContent.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-0 right-0">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {statsItems.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-4 rounded-2xl bg-background-50/10 backdrop-blur-md border border-background-50/10"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/70 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}